import React from "react";
import { addProduct } from "../../actions/basket";
import { picturePlaceholder } from "../../assets/icons";
import { ImgIcon } from "../../assets";
import { useModal } from "../../assets/useModal";
import { trackEvent, EC_SHOP, E_VIEW_PRODUCT_DETAILS } from "../../helpers/tracking";
import QuantitySelector from "../../assets/QuantitySelector";
import { useDeviceSize, MOBILE } from "../../assets/hooks/useDeviceSize";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import ProductInfo from "./ProductInfo";
import LoginModal from "./LoginModal";

// Finds the highest and lowest prices in a list of products.
function getPriceRange(products) {
	let lowest = 0;
	let highest = 0;
	products.forEach(product => {
		if (!lowest || product.price < lowest) lowest = product.price;
		if (!highest || product.price > highest) highest = product.price;
	});
	return [lowest, highest];
}

export default function Product({
	product,
	quantity,
	showPrice,
	showImage = false,
	hoverState = false,
	featureColor,
	variants
}) {

	const dispatch = useDispatch();
	const { device } = useDeviceSize();
	const { openModal, setModal, configModal } = useModal();
	const [lowestPrice, highestPrice] = useMemo(() => getPriceRange([product, ...variants]), [variants, product]);
	const user = useSelector(state => state.session.user && state.session.user.id ? state.session.user : null);

	const image = (product.images || [])[0];
	const hasInfo = (
		(variants && variants.length) ||
		product.description ||
		(product.images && product.images.length) ||
		(product.options && product.options.length)
	);

	function openProduct() {
		configModal({ closable: true });
		setModal(<ProductInfo
			key={product.id}
			product={product}
			quantity={quantity}
			featureColor={featureColor}
			variants={variants}
		/>, `product_${product.id}_main`);
		openModal();
		trackEvent(EC_SHOP, E_VIEW_PRODUCT_DETAILS, `${product.id}_${product.name}`);
	}

	return <div
		className={[
			"product",
			showImage && "has-images",
			hasInfo && "has-info",
			hoverState && "can-hover"
		].filter(c => c).join(" ")}
		onClick={e => {
			e.stopPropagation();
			if (hasInfo) openProduct();
		}}
		key={product.id}
	>
		<div>
			<span>{product.name}</span>
			{Boolean(product.description && device !== MOBILE) && <i> - {product.description.length > 150 ? product.description.slice(0, 150) + "..." : product.description}</i>}
		</div>
		{showPrice && <div className="details featureFont">
			{highestPrice === lowestPrice
				? (
					<span>
						£{(product.price / 100).toFixed(2)}
					</span>
				) : <>
					<span>£{(lowestPrice / 100).toFixed(2)}</span> - <span>£{(highestPrice / 100).toFixed(2)}</span>
				</>
			}
		</div>}
		{showImage && <ImgIcon
            cursor={hasInfo ? "pointer" : "default"}
			bg="#f7f7f7"
			className="product-image"
			src={image ? image.url : picturePlaceholder}
		/>}
		{Boolean(!product.restricted || (product.restricted && variants.length)) && <div
			className="controls v-middle" onClick={e => e.stopPropagation()}
		>
			<QuantitySelector
				value={(!(product.options && product.options.length) && !variants.length) ? quantity : 0}
				onChange={newQuantity => {
					if (variants.length || (product.options && product.options.length)) {
						openProduct();
					} else if (user) {
						dispatch(addProduct(product, newQuantity - quantity));
					} else {
						setModal(<LoginModal />);
						openModal();
					}
				}}
			/>
		</div>}
	</div>
}
